import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const [currentYear, setCurrentYear] = useState<number>(
    new Date().getFullYear()
  ); // State to hold the current year

  useEffect(() => {
    setCurrentYear(new Date().getFullYear());
  }, []);

  return (
    <>
      <div className="row mt-0 pt-0 pb-0 footer-style ">
        <div className="col-lg-6">
          <p className="text-end small-font mt-3 mx-5 me-5">
            {new Date().getFullYear()} &copy; Frayo. All Rights Reserved.
          </p>
        </div> <div className="col-lg-1">
          <p className="text-center small-font mt-3">
            <img src="../assets/cards.png" alt="cards" />
          </p>
        </div>
        <div className="col-lg-5">
          <p className="text-center small-font mt-3">
            <span className="text-end mx-5">
              <Link target="_blank"
                to="https://www.frayo.net/terms-and-condition/"
                className="footer-link cursorPointer me-3"
              >
                Terms & Conditions
              </Link>{" "}
              <Link target="_blank"
                to="https://www.frayo.net/privacy-policy/"
                className="footer-link cursorPointer me-3"
              >
                Privacy Policy
              </Link>{" "}
              <Link target="_blank" to="https://www.frayo.net/refund-policy/" className="footer-link cursorPointer">
                Refund Policy
              </Link>{" "}
            </span>
          </p>
        </div>
      </div>
    </>
  );
};

export default Footer;
